import { ApiTab } from '@/Enums/Attribution/ApiTabs.enum';
import { API_TAB_LABEL } from '@/constants/attribution';
import PrintReportButton from '@/pages/Attribution/Components/PrintReportButton';
import { useAppSelector } from '@/store/hooks';
import { selectVisibleInsightsTabs } from '@/store/selectors/currentWhitelabel.selectors';
import { Radio, RadioGroup } from '@mui/material';
import { ChangeEvent, RefObject, useCallback } from 'react';
import TabChip from './TabChip';

interface IProps {
  currentTab: ApiTab;
  onTabChange: (tab: ApiTab) => void;
  printContainerRef?: RefObject<HTMLDivElement>;
}

const ApiTabs = ({ currentTab, onTabChange, printContainerRef }: IProps) => {
  const visibleTabs = useAppSelector(selectVisibleInsightsTabs);

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value as ApiTab;
      onTabChange(newValue);
    },
    [onTabChange],
  );

  return (
    <div className='flex print:hidden'>
      <RadioGroup
        row
        aria-labelledby='attribution-tabs'
        value={currentTab}
        sx={{
          displayPrint: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '8px',
          marginBottom: '25px',
          width: '100%',
        }}
        onChange={onChange}
      >
        {visibleTabs.map(value => {
          const label = API_TAB_LABEL[value];
          return (
            <Radio
              key={value}
              sx={{ padding: 0 }}
              checkedIcon={<TabChip label={label} checked />}
              icon={<TabChip label={label} />}
              inputProps={{ 'aria-label': label }}
              value={value}
            />
          );
        })}
      </RadioGroup>
      {printContainerRef && <PrintReportButton printContainerRef={printContainerRef} />}
    </div>
  );
};

export default ApiTabs;
